import React from 'react';
import bg from '../../assets/images/background.svg'
import secA from '../../assets/images/cardImages/disclosures.jpg';
import secA_small from '../../assets/images/cardImages/mobile/disclosures.jpg';
import Counter from '../ReusableComponents/counter';

//MUI
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Container } from '@mui/system';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import Woman2RoundedIcon from '@mui/icons-material/Woman2Rounded';
import BadgeIcon from '@mui/icons-material/Badge';
import Groups2Icon from '@mui/icons-material/Groups2';
import EastIcon from '@mui/icons-material/East';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';

//chart js
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

ChartJS.register(ArcElement, Tooltip, Legend);

const counterData = [
    {
        "num": 17083,
        "label": "Employees",
        "icon": Groups2Icon,
        "prefix": "",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 74810,
        "label": "Workers",
        "icon": EngineeringRoundedIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 320,
        "label": "Improvement in Employee Turnover Rate from FY24",
        "icon": BadgeIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": "BPS"
    },
    {
        "num": 13.70,
        "label": "Female Workforce",
        "icon": Woman2RoundedIcon,
        "prefix": "",
        "isdecimal": true,
        "suffix": "%"
    },
    {
        "num": 36.36,
        "label": "Gender Diversity at Board Level",
        "icon": Woman2RoundedIcon,
        "prefix": "",
        "isdecimal": true,
        "suffix": "%"
    },
    {
        "num": 0,
        "label": "Ranked 93 out of 750 global companies in TIME Magazine's World's Most Sustainable Companies 2026 list",
        "icon": MilitaryTechIcon,
        "prefix": "TIME World's Most Sustainable Companies",
        "isdecimal": false,
        "suffix": ""
    },
]


const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));


export const options1 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Employee and Worker Headcount',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key].toLocaleString('en-In');
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 13,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,

            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels1 = ['Employees', 'Workers'];

export const data1 = {
    labels1,
    datasets: [
        {
            label: 'FY23',
            data: {
                "Employees": 13439,
                "Workers": 48435
            },
            backgroundColor: '#747474',
            barThickness: 55
        },
        {
            label: 'FY24',
            data: {
                "Employees": 14264,
                "Workers": 54150
            },
            backgroundColor: '#4d4d4f',
            barThickness: 55
        },
        {
            label: 'FY26',
            data: {
                "Employees": 17083,
                "Workers": 74810
            },
            backgroundColor: '#e31837',
            barThickness: 55
        },
    ],
};

//------------------------------------------------------------------------------------------------
export const options2 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Gender Diversity',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key];
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 14,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,
            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels2 = ['% Women Employees', '% Women Workers'];

export const data2 = {
    labels2,
    datasets: [
        {
            label: 'FY23',
            data: {
                "% Women Employees": 7.47,
                "% Women Workers": 4.28
            },
            backgroundColor: '#747474',
            barThickness: 55
        },
        {
            label: 'FY24',
            data: {
                "% Women Employees": 8.62,
                "% Women Workers": 6.27
            },
            backgroundColor: '#4d4d4f',
            barThickness: 55
        },
        {
            label: 'FY26',
            data: {
                "% Women Employees": 13.70,
                "% Women Workers": 11.03
            },
            backgroundColor: '#e31837',
            barThickness: 55
        },
    ],
};

//------------------------------------------------------------------------------------------
export const options3 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Representation of Women in Board of Directors',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key] + "%";
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 14,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,
            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels3 = ['Board of Directors'];

export const data3 = {
    labels3,
    datasets: [
        {
            label: 'FY23',
            data: {
                "Board of Directors": 25
            },
            backgroundColor: '#747474',
            barThickness: 55
        },
        {
            label: 'FY24',
            data: {
                "Board of Directors": 30
            },
            backgroundColor: '#4d4d4f',
            barThickness: 55
        },
        {
            label: 'FY26',
            data: {
                "Board of Directors": 36.36,
            },
            backgroundColor: '#e31837',
            barThickness: 55
        },
    ],
};

//------------------------------------------------------------------------------------------------
export const options4 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Employee Turnover',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key] + '%';
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 12,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,
            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels4 = ['Male', 'Female', 'Total'];

export const data4 = {
    labels4,
    datasets: [
        {
            label: 'FY23',
            data: {
                "Male": 16.40,
                "Female": 24.90,
                "Total": 17.00
            },
            backgroundColor: '#747474',
            barThickness: 40
        },
        {
            label: 'FY24',
            data: {
                "Male": 13.70,
                "Female": 16.10,
                "Total": 13.80
            },
            backgroundColor: '#4d4d4f',
            barThickness: 40
        },
        {
            label: 'FY26',
            data: {
                "Male": 10.6,
                "Female": 10.8,
                "Total": 10.6
            },
            backgroundColor: '#e31837',
            barThickness: 40
        },
    ],
};

//------------------------------------------------------------------------------------------------
export const options5 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Employee Turnover',
        },
        legend: {
            position: 'top',
            labels: {
                font: {
                    family: 'Georama'
                }
            }
        },
        datalabels: {
            anchor: 'center',
            align: 'bottom',
            formatter: (value, context) => {
                let keys = Object.keys(context.dataset.data)
                let key = keys[context.dataIndex]
                if (context.dataset.data[key] !== 0) {
                    return context.dataset.data[key] + '%';
                }

            },
            padding: -10,
            color: "white",
            font: {
                family: 'Georama',
                size: 12,
                weight: 'bold',

            }
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
        y: {
            display: true,
            grid: {
                display: true,
            },
            ticks: {
                font: {
                    family: 'Georama'
                }
            }
        },
    },
};

const labels5 = ['Male', 'Female', 'Total'];

export const data5 = {
    labels5,
    datasets: [
        {
            label: 'FY23',
            data: {
                "Male": 5.00,
                "Female": 8.80,
                "Total": 5.00
            },
            backgroundColor: '#747474',
            barThickness: 40
        },
        {
            label: 'FY24',
            data: {
                "Male": 5.80,
                "Female": 7.60,
                "Total": 5.80
            },
            backgroundColor: '#4d4d4f',
            barThickness: 40
        },
        {
            label: 'FY26',
            data: {
                "Male": 5.9,
                "Female": 9.9,
                "Total": 5.9
            },
            backgroundColor: '#e31837',
            barThickness: 40
        },
    ],
};

const Sectiona = () => {
    const [expanded1, setExpanded1] = React.useState(false);
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };
    const [expanded2, setExpanded2] = React.useState(false);
    const handleExpandClick2 = () => {
        setExpanded2(!expanded2);
    };
    const [expanded3, setExpanded3] = React.useState(false);
    const handleExpandClick3 = () => {
        setExpanded3(!expanded3);
    };
    const [expanded4, setExpanded4] = React.useState(false);
    const handleExpandClick4 = () => {
        setExpanded4(!expanded4);
    };
    const [expanded5, setExpanded5] = React.useState(false);
    const handleExpandClick5 = () => {
        setExpanded5(!expanded5);
    };
    const [expanded6, setExpanded6] = React.useState(false);
    const handleExpandClick6 = () => {
        setExpanded6(!expanded6);
    };
    const [expanded7, setExpanded7] = React.useState(false);
    const handleExpandClick7 = () => {
        setExpanded7(!expanded7);
    };
    const [expand, setExpand] = React.useState(false);
    const expandAll = () => {
        setExpand(true);
        setExpanded2(true);
        setExpanded1(true);
        setExpanded3(true);
        setExpanded4(true);
        setExpanded5(true);
        setExpanded6(true);
        setExpanded7(true);
    };
    const closeAll = () => {
        setExpand(false);
        setExpanded1(false);
        setExpanded2(false);
        setExpanded3(false);
        setExpanded4(false);
        setExpanded5(false);
        setExpanded6(false);
        setExpanded7(false);
    };

    return (
        <Container>
            <Box mt={3} sx={{ display: 'flex', justifyContent: 'end' }}>
                <Button endIcon={<EastIcon />} sx={{ fontWeight: 'bold' }} href='/sectionb'>
                    Next
                </Button>
            </Box>
            <Box mt={3} sx={{
                display: 'flex',
                alignItems: 'center',
                height: { xs: '150px', md: '300px' },
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                borderRadius: '8px'
            }}>
                <Box p={5} sx={{ width: '100%' }}>
                    <Typography sx={{ typography: { xs: 'h5', md: 'h4' }, color: "#ffffff" }}>
                        General Disclosures
                    </Typography>
                </Box>
                <Box sx={{
                    display: 'flex',
                    backgroundImage: { xs: `url(${secA_small})`, sm: `url(${secA})` },
                    backgroundSize: 'cover',
                    borderRadius: '0 8px 8px 0',
                    height: { xs: '150px', md: '300px' },
                    width: '100%'
                }}>
                </Box>
            </Box>
            <Box px={4} py={6} mt={{ xs: 4, md: 8 }} sx={{ backgroundColor: '#e6e7e8', borderRadius: '8px' }}>
                <Box mb={6} display="flex" justifyContent="center">
                    <Typography className='heading' variant='h4' sx={{ color: "#e31837", fontSize: "34px", fontWeight: "900" }}>
                        Highlights
                    </Typography>
                </Box>
                <Box>
                    <Counter data={counterData} />
                </Box>
            </Box>
            <Box mt={5} sx={{ textAlign: "right" }}>
                <button onClick={!expand ? expandAll : closeAll} className="custom-button">
                    <span>
                        {!expand ? 'Expand All' : "Close All"}
                        {!expand ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </span>
                </button>
            </Box>
            <Box my={4}>
                <Box mt={4} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                    <Box mb={2}>
                        <Box>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                                I. Details
                                <ExpandMore
                                    expand={expanded1}
                                    onClick={handleExpandClick1}
                                    aria-expanded={expanded1}
                                    aria-label="show more"
                                >
                                    <ExpandMoreIcon />
                                </ExpandMore>
                            </Typography>
                        </Box>
                    </Box>
                    <Collapse in={expanded1} timeout="auto" unmountOnExit>
                        <Box mb={5}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} size="small">
                                    <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                        <TableRow sx={{ backgroundColor: "#4d4d4f", "& td": { color: '#ffffff' } }} >
                                            <TableCell align="center"><strong>Sr. No.</strong></TableCell>
                                            <TableCell align="left" sx={{ minWidth: '400px' }}><strong>Particulars held</strong></TableCell>
                                            <TableCell align="left"><strong>Response</strong></TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>1</strong></TableCell>
                                            <TableCell><strong>Corporate Identity Number (CIN) of the Listed Entity</strong></TableCell>
                                            <TableCell>L65990MH1945PLC004558</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>2</strong></TableCell>
                                            <TableCell><strong>Name of the Listed Entity</strong></TableCell>
                                            <TableCell>Mahindra & Mahindra Limited</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>3</strong></TableCell>
                                            <TableCell><strong>Year of incorporation</strong></TableCell>
                                            <TableCell>1945</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>4</strong></TableCell>
                                            <TableCell><strong>Registered office address</strong></TableCell>
                                            <TableCell>Gateway Building, Apollo Bunder, Mumbai - 400001</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>5</strong></TableCell>
                                            <TableCell><strong>Corporate address</strong></TableCell>
                                            <TableCell>Mahindra Towers, Dr. G. M. Bhosale Marg, Worli, Mumbai - 400018</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>6</strong></TableCell>
                                            <TableCell><strong>E-mail</strong></TableCell>
                                            <TableCell><a href='mailto:investors@mahindra.com'>investors@mahindra.com</a></TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>7</strong></TableCell>
                                            <TableCell><strong>Telephone</strong></TableCell>
                                            <TableCell>+9122 6897 5500</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>8</strong></TableCell>
                                            <TableCell><strong>Website</strong></TableCell>
                                            <TableCell><a href='https://www.mahindra.com/' target="_blank" rel="noopener noreferrer">www.mahindra.com</a></TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>9</strong></TableCell>
                                            <TableCell><strong>Financial year for which reporting is being done</strong></TableCell>
                                            <TableCell>01-04-2025 to 31-03-2026</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>10</strong></TableCell>
                                            <TableCell><strong>Name of the Stock Exchange(s) where shares are listed</strong></TableCell>
                                            <TableCell>The Company’s Ordinary (Equity) Shares are listed on BSE Limited (‘BSE’) and National Stock Exchange of India Limited (‘NSE’). The Global Depository Receipts (‘GDR’s) of the Company are listed on the Luxembourg Stock Exchange and are also admitted for trading on International Order Book (IOB) of the London Stock Exchange. The Company’s privately placed Non-Convertible Debentures (‘NCD’s) are listed on the Debt Segment of BSE.</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>11</strong></TableCell>
                                            <TableCell><strong>Paid-up Capital</strong></TableCell>
                                            <TableCell>₹ 6,21,76,44,155</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell rowSpan={4} component="th" scope="row" align='center'><strong>12</strong></TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell><strong>Name of Contact Person</strong></TableCell>
                                            <TableCell>Rajeev Goyal <br /> CEO - Agri and New Energy Businesses</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell><strong>Contact Number of Contact Person</strong></TableCell>
                                            <TableCell>+9122 2884 9702</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell><strong>Email of Contact Person</strong></TableCell>
                                            <TableCell><a href='mailto:goyal.rajeev@mahindra.com'>goyal.rajeev@mahindra.com</a></TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>13</strong></TableCell>
                                            <TableCell><strong>Reporting Boundary</strong></TableCell>
                                            <TableCell>The disclosures under this report are made on Standalone basis.</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>14</strong></TableCell>
                                            <TableCell><strong>Name of assessment or assurance provider</strong></TableCell>
                                            <TableCell>DNV Business Assurance India Private Limited</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" align='center'><strong>15</strong></TableCell>
                                            <TableCell><strong>Type of assessment or assurance obtained</strong></TableCell>
                                            <TableCell>Reasonable Assurance obtained on the BRSR Core KPIs</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Collapse>
                </Box>
                <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                    <Box mb={2}>
                        <Box>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                                II. Products/ Services
                                <ExpandMore
                                    expand={expanded2}
                                    onClick={handleExpandClick2}
                                    aria-expanded={expanded2}
                                    aria-label="show more"
                                >
                                    <ExpandMoreIcon />
                                </ExpandMore>
                            </Typography>
                        </Box>
                    </Box>
                    <Collapse in={expanded2} timeout="auto" unmountOnExit>
                        <Box mb={5}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} size="small">
                                    <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                        <TableRow sx={{ backgroundColor: "#4d4d4f", "& td": { color: '#ffffff' } }} >
                                            <TableCell rowSpan={2} sx={{ backgroundColor: "#ffffff", color: '#000000 !important' }} align="center">16</TableCell>
                                            <TableCell rowSpan={2} sx={{ maxWidth: '140px' }} align="left"><strong>Details of business activities </strong></TableCell>
                                            <TableCell align="left"><strong>Sr. No.</strong></TableCell>
                                            <TableCell align="left"><strong>Description of Main Activity</strong></TableCell>
                                            <TableCell align="left"><strong>Description of Business Activity</strong></TableCell>
                                            <TableCell align="left"><strong>% Turnover of the entity</strong></TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align='left'>1</TableCell>
                                            <TableCell align='left'>Manufacturing</TableCell>
                                            <TableCell align='left'>Motor vehicles, trailers, semi-trailers and other Transport Vehicles</TableCell>
                                            <TableCell align='left'>100</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: "#4d4d4f", "& td": { color: '#ffffff' } }} >
                                            <TableCell rowSpan={3} sx={{ backgroundColor: "#ffffff", color: '#000000 !important' }} align="center">17</TableCell>
                                            <TableCell rowSpan={3} sx={{ maxWidth: '140px' }} align="left"><strong>Products/ Services sold by the entity</strong></TableCell>
                                            <TableCell align="left"><strong>Sr. No.</strong></TableCell>
                                            <TableCell align="left"><strong>Product/ Service</strong></TableCell>
                                            <TableCell align="left"><strong>NIC Code</strong></TableCell>
                                            <TableCell align="left"><strong>% of Total Turnover contributed</strong></TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align='left'>1</TableCell>
                                            <TableCell align='left'>Automotive</TableCell>
                                            <TableCell align='left'>29101, 29102, 29103, 29104, 29109, 28243</TableCell>
                                            <TableCell align='left'>75.01</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align='left'>2</TableCell>
                                            <TableCell align='left'>Farm Equipment</TableCell>
                                            <TableCell align='left'>28211, 28212</TableCell>
                                            <TableCell align='left'>24.99</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Collapse>
                </Box>
                <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                    <Box mb={2}>
                        <Box>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                                III. Operations
                                <ExpandMore
                                    expand={expanded3}
                                    onClick={handleExpandClick3}
                                    aria-expanded={expanded3}
                                    aria-label="show more"
                                >
                                    <ExpandMoreIcon />
                                </ExpandMore>
                            </Typography>
                        </Box>
                    </Box>
                    <Collapse in={expanded3} timeout="auto" unmountOnExit>
                        <Box mb={5}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} size="small">
                                    <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                        <TableRow sx={{ backgroundColor: "#4d4d4f", "& td": { color: '#ffffff' } }} >
                                            <TableCell rowSpan={3} sx={{ backgroundColor: "#ffffff", color: '#000000 !important' }} align="center">18</TableCell>
                                            <TableCell rowSpan={3} sx={{ maxWidth: '140px' }} align="left"><strong>Number of locations where plants and/ or operations/ offices of the entity are situated: </strong></TableCell>
                                            <TableCell align="left"><strong>Location</strong></TableCell>
                                            <TableCell align="left"><strong>Number of plants</strong></TableCell>
                                            <TableCell align="left"><strong>Number of offices</strong></TableCell>
                                            <TableCell align="left"><strong>Total</strong></TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align='left'>National</TableCell>
                                            <TableCell align='left'>55</TableCell>
                                            <TableCell align='left'>127</TableCell>
                                            <TableCell align='left'>182</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align='left'>International</TableCell>
                                            <TableCell align='left'>24</TableCell>
                                            <TableCell align='left'>19</TableCell>
                                            <TableCell align='left'>43</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: "#4d4d4f", "& td": { color: '#ffffff' } }} >
                                            <TableCell rowSpan={5} sx={{ backgroundColor: "#ffffff", color: '#000000 !important' }} align="center">19</TableCell>
                                            <TableCell sx={{ maxWidth: '140px' }} align="left"><strong>Market served by the entity</strong></TableCell>
                                            <TableCell colSpan={2} align="left"><strong>Location</strong></TableCell>
                                            <TableCell colSpan={2} align="left"><strong>Numbers</strong></TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell rowSpan={2} align='left' sx={{ backgroundColor: "#4d4d4f", color: '#ffffff !important' }}>a.	No. of Locations</TableCell>
                                            <TableCell colSpan={2} align='left'>National (No. of States)</TableCell>
                                            <TableCell colSpan={2} align='left'>28 States and 6 Union Territories</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell colSpan={2} align='left'>International (No. of Countries)</TableCell>
                                            <TableCell colSpan={2} align='left'>46</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align='left' sx={{ backgroundColor: "#4d4d4f", color: '#ffffff !important' }}>b. What is the contribution of exports as a percentage of the total turnover of the entity?</TableCell>
                                            <TableCell colSpan={4} align='left'>4.11%</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell align='left' sx={{ backgroundColor: "#4d4d4f", color: '#ffffff !important' }}>c. A brief on types of customers</TableCell>
                                            <TableCell colSpan={4} align='left'>The Company serves a wide spectrum of customers, including urban and rural populations, government agencies, corporates, Small and Medium Enterprises (SMEs), agricultural and non-agricultural businesses, as well as tours and travels operators amongst others. The Company's Passenger Vehicles business vertical caters to a diverse range of customers across economic profiles and geographies.
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Collapse>
                </Box>
                <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                    <Box mb={2}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            IV. Employees
                            <ExpandMore
                                expand={expanded4}
                                onClick={handleExpandClick4}
                                aria-expanded={expanded4}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                    <Collapse in={expanded4} timeout="auto" unmountOnExit>
                        <Box mb={4}>
                            <Typography variant='body1'>
                                <strong>20. Details as at the end of Financial Year:</strong>
                            </Typography>
                        </Box>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" rowSpan={2}><strong>Sr. No.</strong></TableCell>
                                        <TableCell align="center" rowSpan={2}><strong>Particulars</strong></TableCell>
                                        <TableCell align="center" rowSpan={2}><strong>Total (A)</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Male</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>Female</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>No. (B)</strong></TableCell>
                                        <TableCell align="center"><strong>% (B/A)</strong></TableCell>
                                        <TableCell align="center"><strong>No. (C)</strong></TableCell>
                                        <TableCell align="center"><strong>% (C/A)</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    {/* Employees Header */}
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ backgroundColor: "#e6e7e8" }} component="th" scope="row" align='center' colSpan={7}><strong>Employees</strong></TableCell>
                                    </TableRow>

                                    {/* a. Employees (including differently abled) */}
                                    <TableRow>
                                        <TableCell component="th" scope="row" align='left' colSpan={7}><strong>a. Employees (including differently abled)</strong></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">1</TableCell>
                                        <TableCell>Permanent (D)</TableCell>
                                        <TableCell align='center'>16,642</TableCell>
                                        <TableCell align='center'>14,476</TableCell>
                                        <TableCell align='center'>86.98</TableCell>
                                        <TableCell align='center'>2,166</TableCell>
                                        <TableCell align='center'>13.02</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">2</TableCell>
                                        <TableCell>Other than Permanent (E)</TableCell>
                                        <TableCell align='center'>441</TableCell>
                                        <TableCell align='center'>266</TableCell>
                                        <TableCell align='center'>60.32</TableCell>
                                        <TableCell align='center'>175</TableCell>
                                        <TableCell align='center'>39.68</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">3</TableCell>
                                        <TableCell>Total employees (D + E)</TableCell>
                                        <TableCell align='center'>17,083</TableCell>
                                        <TableCell align='center'>14,742</TableCell>
                                        <TableCell align='center'>86.30</TableCell>
                                        <TableCell align='center'>2,341</TableCell>
                                        <TableCell align='center'>13.70</TableCell>
                                    </TableRow>

                                    {/* b. Differently abled Employees */}
                                    <TableRow>
                                        <TableCell component="th" scope="row" align='left' colSpan={7}><strong>b. Differently abled Employees</strong></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">1</TableCell>
                                        <TableCell>Permanent</TableCell>
                                        <TableCell align='center'>6</TableCell>
                                        <TableCell align='center'>6</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">2</TableCell>
                                        <TableCell>Other than Permanent</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">3</TableCell>
                                        <TableCell>Total</TableCell>
                                        <TableCell align='center'>6</TableCell>
                                        <TableCell align='center'>6</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                    </TableRow>

                                    {/* Workers Header */}
                                    <TableRow>
                                        <TableCell sx={{ backgroundColor: "#e6e7e8" }} component="th" scope="row" align='center' colSpan={7}><strong>Workers</strong></TableCell>
                                    </TableRow>

                                    {/* c. Workers (including differently abled) */}
                                    <TableRow>
                                        <TableCell component="th" scope="row" align='left' colSpan={7}><strong>c. Workers (including differently abled)</strong></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">4</TableCell>
                                        <TableCell>Permanent (F)</TableCell>
                                        <TableCell align='center'>10,123</TableCell>
                                        <TableCell align='center'>10,060</TableCell>
                                        <TableCell align='center'>99.38</TableCell>
                                        <TableCell align='center'>63</TableCell>
                                        <TableCell align='center'>0.62</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">5</TableCell>
                                        <TableCell>Other than Permanent (G)</TableCell>
                                        <TableCell align='center'>64,687</TableCell>
                                        <TableCell align='center'>56,502</TableCell>
                                        <TableCell align='center'>87.35</TableCell>
                                        <TableCell align='center'>8,185</TableCell>
                                        <TableCell align='center'>12.65</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">6</TableCell>
                                        <TableCell>Total workers (F + G)</TableCell>
                                        <TableCell align='center'>74,810</TableCell>
                                        <TableCell align='center'>66,562</TableCell>
                                        <TableCell align='center'>88.97</TableCell>
                                        <TableCell align='center'>8,248</TableCell>
                                        <TableCell align='center'>11.03</TableCell>
                                    </TableRow>

                                    {/* d. Differently abled Workers */}
                                    <TableRow>
                                        <TableCell component="th" scope="row" align='left' colSpan={7}><strong>d. Differently abled Workers</strong></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">1</TableCell>
                                        <TableCell>Permanent</TableCell>
                                        <TableCell align='center'>4</TableCell>
                                        <TableCell align='center'>4</TableCell>
                                        <TableCell align='center'>100.00</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">2</TableCell>
                                        <TableCell>Other than Permanent</TableCell>
                                        <TableCell align='center'>29</TableCell>
                                        <TableCell align='center'>25</TableCell>
                                        <TableCell align='center'>86.21</TableCell>
                                        <TableCell align='center'>4</TableCell>
                                        <TableCell align='center'>13.79</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component="th" scope="row">3</TableCell>
                                        <TableCell>Total</TableCell>
                                        <TableCell align='center'>33</TableCell>
                                        <TableCell align='center'>29</TableCell>
                                        <TableCell align='center'>87.88</TableCell>
                                        <TableCell align='center'>4</TableCell>
                                        <TableCell align='center'>12.12</TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                        </TableContainer>
                        <Typography mt={2} variant='body2'>* Numbers mentioned under “Differently abled Employees/Workers” are based on voluntary disclosures from employees & workers</Typography>
                        <Box mt={5} sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            <Box sx={{ mx: 'auto', width: { xs: '100%', md: '49%' } }}>
                                <Box p={3} sx={{ backgroundColor: '#e31837' }} display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
                                    <Box>
                                        <Typography variant='h6' sx={{ color: 'white', fontWeight: 'bold' }}>
                                            Employee and Worker Headcount
                                        </Typography>
                                    </Box>
                                    <Box mt={1}>
                                        <Typography variant='body2' sx={{ color: 'white' }}>
                                            Increase in employees and workers headcount
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box p={6} sx={{ border: "1.5px solid #e31837 ", height: '400px' }}>
                                    <Box sx={{ overflowX: 'auto', width: '100%' }}>
                                        <Box sx={{ minWidth: '450px', height: '350px' }}>
                                            <Bar options={options1} data={data1} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={{ py: 2, width: { xs: '100%', md: '2%' } }}></Box>
                            <Box sx={{ mx: 'auto', width: { xs: '100%', md: '49%' } }}>
                                <Box p={3} sx={{ backgroundColor: '#e31837' }} display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
                                    <Box>
                                        <Typography variant='h6' sx={{ color: 'white', fontWeight: 'bold' }}>
                                            Gender Diversity
                                        </Typography>
                                    </Box>
                                    <Box mt={1}>
                                        <Typography variant='body2' sx={{ color: 'white' }}>
                                            Increased share of women in total workforce
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box p={6} sx={{ border: "1.5px solid #e31837 ", height: '400px' }}>
                                    <Box sx={{ overflowX: 'auto', width: '100%' }}>
                                        <Box sx={{ minWidth: '450px', height: '350px' }}>
                                            <Bar options={options2} data={data2} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Box mt={5} mb={3}>
                            <Typography variant='body1'>
                                <strong>21. Participation/ Inclusion/ Representation of women</strong>
                            </Typography>
                        </Box>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" rowSpan={2}><strong>Sr. No.</strong></TableCell>
                                        <TableCell align="left" rowSpan={2}><strong>Category</strong></TableCell>
                                        <TableCell align="center" rowSpan={2}><strong>Total (A)</strong></TableCell>
                                        <TableCell align="center" colSpan={2}><strong>No. and % of Females</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center"><strong>No. (B)</strong></TableCell>
                                        <TableCell align="center"><strong>% (B/A)</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align='center'>1</TableCell>
                                        <TableCell align='left'>Board of Directors</TableCell>
                                        <TableCell align='center'>11</TableCell>
                                        <TableCell align='center'>4</TableCell>
                                        <TableCell align='center'>36.36</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align='center'>2</TableCell>
                                        <TableCell align='left'>Key Management Personnel</TableCell>
                                        <TableCell align='center'>4</TableCell>
                                        <TableCell align='center'>0</TableCell>
                                        <TableCell align='center'>0.00</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography mt={2} variant='body2'>
                            Notes:
                            <br />
                            1. Dr. Anish Shah, Group CEO and Managing Director, and Mr. Rajesh Jejurikar, Executive Director & CEO (Auto and Farm Sector), are classified under both the Board of Directors and Key Management Personnel, in compliance with applicable provisions.
                            <br />
                            2. Mr. M. P. Vijay Kumar and Ms. Samina Hamied were appointed as Independent Directors with effect from 7th October 2025, and form part of the Board of Directors as on 31st March 2026.
                            <br />
                            3. Mr. T. N. Manoharan ceased to hold office as an Independent Director with effect from 30th July 2025, due to his unfortunate demise.
                            <br />
                            4. Mr. Narayan Shankar, Company Secretary and Key Management Personnel, retired with effect from 1st April 2025.
                            <br />
                            5. Ms. Divya Mascarenhas was appointed as Interim Company Secretary and Key Management Personnel with effect from 2nd April 2025 and ceased to hold office as Interim Company Secretary at the close of business hours on 15th July 2025.
                            <br />
                            6. Mr. Sailesh Kumar Daga was appointed as Company Secretary and Key Management Personnel with effect from 16th July 2025.
                        </Typography>
                        <Box sx={{ mx: 'auto', width: { md: '100%', lg: '60%' } }} mt={4} mb={8}>
                            <Box p={3} sx={{ backgroundColor: '#e31837' }} display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
                                <Box>
                                    <Typography variant='h6' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        Representation of Women in Board of Directors
                                    </Typography>
                                </Box>
                            </Box>
                            <Box p={6} sx={{ border: "1.5px solid #e31837 ", height: '400px' }}>
                                <Bar options={options3} data={data3} />
                            </Box>

                        </Box>
                        <Box mt={5} mb={3}>
                            <Typography variant='body1'>
                                <strong>22. Turnover rate for permanent employees and workers.</strong>
                            </Typography>
                        </Box>
                        <Box mb={5}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} size="small">
                                    <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                        <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                            <TableCell align="center" rowSpan={2}><strong></strong></TableCell>
                                            <TableCell align="center" colSpan={3}><strong>FY26<br></br>(Turnover rate in current FY)</strong></TableCell>
                                            <TableCell align="center" colSpan={3}><strong>FY25<br></br>(Turnover rate in previous FY)</strong></TableCell>
                                            <TableCell align="center" colSpan={3}><strong>FY24<br></br>(Turnover rate in the year prior to previous FY)</strong></TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                            <TableCell align="center" ><strong>Male</strong></TableCell>
                                            <TableCell align="center" ><strong>Female</strong></TableCell>
                                            <TableCell align="center" ><strong>Total</strong></TableCell>
                                            <TableCell align="center" ><strong>Male</strong></TableCell>
                                            <TableCell align="center" ><strong>Female</strong></TableCell>
                                            <TableCell align="center" ><strong>Total</strong></TableCell>
                                            <TableCell align="center" ><strong>Male</strong></TableCell>
                                            <TableCell align="center" ><strong>Female</strong></TableCell>
                                            <TableCell align="center" ><strong>Total</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">Permanent Employees</TableCell>
                                            <TableCell align='center'>10.6%</TableCell>
                                            <TableCell align='center'>10.8%</TableCell>
                                            <TableCell align='center'>10.6%</TableCell>
                                            <TableCell align='center'>10.7%</TableCell>
                                            <TableCell align='center'>12.0%</TableCell>
                                            <TableCell align='center'>10.8%</TableCell>
                                            <TableCell align='center'>13.7%</TableCell>
                                            <TableCell align='center'>16.1%</TableCell>
                                            <TableCell align='center'>13.8%</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">Permanent Workers*</TableCell>
                                            <TableCell align='center'>5.9%</TableCell>
                                            <TableCell align='center'>9.9%</TableCell>
                                            <TableCell align='center'>5.9%</TableCell>
                                            <TableCell align='center'>4.1%</TableCell>
                                            <TableCell align='center'>1.9%</TableCell>
                                            <TableCell align='center'>4.1%</TableCell>
                                            <TableCell align='center'>5.8%</TableCell>
                                            <TableCell align='center'>7.6%</TableCell>
                                            <TableCell align='center'>5.8%</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Typography mt={2} variant='body2'>
                                * Includes workers opted for retirement under voluntary retirement scheme of the Company.
                            </Typography>
                        </Box>
                        <Box mb={5} sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            <Box sx={{ mx: 'auto', width: { xs: '100%', md: '49%' } }}>
                                <Box p={3} sx={{ backgroundColor: '#e31837' }} display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
                                    <Box>
                                        <Typography variant='h6' sx={{ color: 'white', fontWeight: 'bold' }}>
                                            % Turnover Rate - Permanent Employee
                                        </Typography>
                                    </Box>
                                    <Box mt={1}>
                                        <Typography variant='body2' sx={{ color: 'white' }}>
                                            Decreasing trend of turnover rate
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box p={6} sx={{ border: "1.5px solid #e31837 ", height: '400px' }}>
                                    <Box sx={{ overflowX: 'auto', width: '100%' }}>
                                        <Box sx={{ minWidth: '450px', height: '350px' }}>
                                            <Bar options={options4} data={data4} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={{ py: 2, width: { xs: '100%', md: '2%' } }}></Box>
                            <Box sx={{ mx: 'auto', width: { xs: '100%', md: '49%' } }}>
                                <Box p={3} sx={{ backgroundColor: '#e31837' }} display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
                                    <Box>
                                        <Typography variant='h6' sx={{ color: 'white', fontWeight: 'bold' }}>
                                            % Turnover Rate - Permanent Worker
                                        </Typography>
                                    </Box>
                                    <Box mt={1}>
                                        <Typography variant='body2' sx={{ color: 'white' }}>
                                            Decreasing trend of turnover rate
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box p={6} sx={{ border: "1.5px solid #e31837 ", height: '400px' }}>
                                    <Box sx={{ overflowX: 'auto', width: '100%' }}>
                                        <Box sx={{ minWidth: '450px', height: '350px' }}>
                                            <Bar options={options5} data={data5} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Collapse>
                </Box>
                <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                    <Box mb={2}>
                        <Box>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                                V. Holding, Subsidiary and Associate Companies (including joint ventures)
                                <ExpandMore
                                    expand={expanded5}
                                    onClick={handleExpandClick5}
                                    aria-expanded={expanded5}
                                    aria-label="show more"
                                >
                                    <ExpandMoreIcon />
                                </ExpandMore>
                            </Typography>
                        </Box>
                    </Box>
                    <Collapse in={expanded5} timeout="auto" unmountOnExit>
                        <Box mb={3}>
                            <Typography variant='body1'>
                                <strong>23. Names of holding/ subsidiary/ associate companies/ joint ventures.</strong>
                            </Typography>
                            <Typography variant='body1'>
                                For the year FY 2025-26, the below mentioned subsidiaries are those who have participated in Business Responsibility initiatives of the Company. The list of other subsidiaries, associates and joint ventures of the Company is provided in Form AOC-1 and forms part of this Annual Report:
                            </Typography>
                        </Box>
                        <Box mb={5}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} size="small">
                                    <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                        <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                            <TableCell align="left"><strong>Sr. No.</strong></TableCell>
                                            <TableCell sx={{ minWidth: '230px' }} align="center"><strong>Name of the holding/ subsidiary/ associate companies/ joint ventures (A)</strong></TableCell>
                                            <TableCell align="center" ><strong>Indicate whether holding/ Subsidiary/ Associate/ Joint Venture</strong></TableCell>
                                            <TableCell align="center"><strong>% of shares held by listed entity</strong></TableCell>
                                            <TableCell align="center"><strong>Does the entity indicated at column A, participate in the Business Responsibility initiatives of the listed entity? (Yes/ No)</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">1</TableCell>
                                            <TableCell>Mahindra Steel Service Centre Limited**</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>61.00%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">2</TableCell>
                                            <TableCell>Mahindra Agri Solutions Limited</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>99.06%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">3</TableCell>
                                            <TableCell>Mahindra Accelo Limited</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>100.00%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">4</TableCell>
                                            <TableCell>Mahindra Holidays & Resorts India Limited</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>66.74%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">5</TableCell>
                                            <TableCell>Mahindra & Mahindra Financial Services Limited</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>52.49%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">6</TableCell>
                                            <TableCell>Mahindra Insurance Brokers Limited**</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>100.00%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">7</TableCell>
                                            <TableCell>Mahindra Rural Housing Finance Limited**</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>98.43%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">8</TableCell>
                                            <TableCell>Mahindra Lifespace Developers Limited</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>52.41%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">9</TableCell>
                                            <TableCell>Mahindra World City (Jaipur) Limited**</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>74.00%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">10</TableCell>
                                            <TableCell>Mahindra World City Developers Limited**</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>89.00%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">11</TableCell>
                                            <TableCell>Mahindra Logistics Limited</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>59.58%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">12</TableCell>
                                            <TableCell>Mahindra Susten Private Limited**</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>60.01%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">13</TableCell>
                                            <TableCell>Mahindra EPC Irrigation Limited</TableCell>
                                            <TableCell align='center'>Subsidiary</TableCell>
                                            <TableCell align='center'>54.20%</TableCell>
                                            <TableCell align='center'>Yes</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Typography mt={2} variant='body2'>
                                * Percentage holding in subsidiaries represents aggregate percentage of shares/voting power held by the Company and/or its subsidiaries.<br />
                                ** Step-down Subsidiary
                            </Typography>
                        </Box>
                    </Collapse>
                </Box>
                <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                    <Box mb={2}>
                        <Box>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                                VI. CSR Details
                                <ExpandMore
                                    expand={expanded6}
                                    onClick={handleExpandClick6}
                                    aria-expanded={expanded6}
                                    aria-label="show more"
                                >
                                    <ExpandMoreIcon />
                                </ExpandMore>
                            </Typography>
                        </Box>
                    </Box>
                    <Collapse in={expanded6} timeout="auto" unmountOnExit>
                        <Box mb={2}>
                            <Typography variant='body1'>
                                <strong>24. Whether CSR is applicable as per section 135 of Companies Act, 2013: (Yes/ No).</strong>
                                <br></br>
                                <Box mt={1}>Yes</Box>
                            </Typography>
                        </Box>
                        <Box mb={5}>
                            <TableContainer sx={{ maxWidth: 700 }} component={Paper}>
                                <Table size="small">
                                    <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row"><strong>Turnover (in Rs. crores)</strong></TableCell>
                                            <TableCell>1,45,575.77</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row"><strong>Net worth (in Rs. crores)</strong></TableCell>
                                            <TableCell>73,994.77</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Collapse>
                </Box>
                <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                    <Box mb={2}>
                        <Box>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                                VII. Transparency and Disclosures Compliances
                                <ExpandMore
                                    expand={expanded7}
                                    onClick={handleExpandClick7}
                                    aria-expanded={expanded7}
                                    aria-label="show more"
                                >
                                    <ExpandMoreIcon />
                                </ExpandMore>
                            </Typography>
                        </Box>
                    </Box>
                    <Collapse in={expanded7} timeout="auto" unmountOnExit>
                        <Box mb={4}>
                            <Typography variant='body1'>
                                <strong>25. Complaints/ Grievances on any of the principles (Principles 1 to 9) under the National Guidelines on Responsible Business Conduct:</strong>
                            </Typography>
                        </Box>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: { xs: 1200, md: 700 } }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center" rowSpan={2}><strong>Stakeholder group from whom complaint is received</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center" rowSpan={2}><strong>Grievance Redressal Mechanism in Place (Yes/ No)</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center" rowSpan={2}><strong>If Yes, then provide web-link for grievance redress policy</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center" colSpan={3}><strong>FY 2025-26 <br />(Current Financial Year)</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center" colSpan={3}><strong>FY 2024-25 <br />(Previous Financial Year)</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center"><strong>Number of complaints filed during the year</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center"><strong>Number of complaints pending resolution at close of the year</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center"><strong>Remarks</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center"><strong>Number of complaints filed during the year</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center"><strong>Number of complaints pending resolution at close of the year</strong></TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align="center"><strong>Remarks</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">Communities</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>Yes</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='justify'>
                                            The Company maintains a grievance redressal mechanism at each plant, providing community members with a channel to register concerns.
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">Investors (other than shareholders)</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>Yes</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='left'>
                                            Name of the Policy:<br /> Investors Grievance Redressal Policy.<br />
                                            Web-Link: <a href='https://www.mahindra.com/investor-relations/policies-and-documents' target="_blank" rel="noopener noreferrer">https://www.mahindra.com/investor-relations/policies-and-documents</a>
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">Shareholders</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>Yes</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='left'>
                                            Name of the Policy:<br /> Investors Grievance Redressal Policy.<br />
                                            Web-Link: <a href='https://www.mahindra.com/investor-relations/policies-and-documents' target="_blank" rel="noopener noreferrer">https://www.mahindra.com/investor-relations/policies-and-documents</a>
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>129*</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>1</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>47*</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">Employees and workers</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>Yes</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='left'>
                                            Name of the Policy:<br /> Code of Conduct for Employees.<br />
                                            Web-Link: <a href='https://www.mahindra.com/investor-relations/policies-and-documents' target="_blank" rel="noopener noreferrer">https://www.mahindra.com/investor-relations/policies-and-documents</a>
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>208**</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>43</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>126</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>10</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">Customers***</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>Yes</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='justify'>
                                            Across the Company's touch points like Owner's Manual, Website, With You Hamesha (WYH) App & Repair Orders, customers are guided to connect with the registered customer care email id or toll-free number for any feedback.
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>99,195***</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>2,016</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>83,288</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>1,463</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">Value Chain Partners</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>Yes</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='left'>
                                            Name of the Policy:<br /> Suppliers Code of Conduct.<br />
                                            Web-Link: <a href='https://www.mahindra.com/investor-relations/policies-and-documents' target="_blank" rel="noopener noreferrer">https://www.mahindra.com/investor-relations/policies-and-documents</a>
                                        </TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>0</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} component="th" scope="row">Other (please specify)</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>-</TableCell>
                                        <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>NA</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography mt={2} variant='body2'>
                            * Please note that the complaints received from shareholders pertain to non-receipt of shares, dividend, annual report etc. and not under any specific principles of National Guidelines on Responsible Business Conduct. The increase in shareholders' complaints during the reporting year is primarily due to regulatory changes, growth in the shareholder base, and increased investor awareness.<br />
                            ** The increase in employee complaints reflects strengthened grievance redressal mechanisms, and improved employee awareness, leading to greater transparency. Certain cases remain open as they are under detailed review to ensure fair and comprehensive resolution.<br />
                            *** We adopt a proactive approach to identifying and addressing customer complaints. The reported figures include both service- and sales-related complaints, contributing to the overall volume. In FY26, pre-sales have been excluded, as these primarily relate to enquiries and are not classified as complaints
                        </Typography>
                        <Box my={4}>
                            <Typography variant='body1'>
                                <strong>26. Overview of the entity's material responsible business conduct issues pertaining to environmental and social matters that present a risk or an opportunity to your business, rationale for identifying the same, approach to adapt or mitigate the risk along-with its financial implications</strong>
                            </Typography>
                        </Box>
                        <Box mb={5}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: { xs: 1200, md: 700 } }} size="small">
                                    <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                        <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                            <TableCell align="center"><strong>Sr. No.</strong></TableCell>
                                            <TableCell><strong>Material Issue Identified</strong></TableCell>
                                            <TableCell><strong>Indicate whether risk or opportunity (R/O)</strong></TableCell>
                                            <TableCell><strong>Rationale for identifying the risk/ opportunity</strong></TableCell>
                                            <TableCell><strong>In case of risk, approach to adapt or mitigate</strong></TableCell>
                                            <TableCell><strong>Financial implications of the risk or opportunity (Indicate positive or negative implications)</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>1</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>Product Stewardship</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>O</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                The Company continuously reviews and improves its product stewardship by integrating advanced quality control processes and aligning product design with the highest safety and sustainability standards. This includes comprehensive R&D initiatives and close monitoring of customer feedback to align with evolving expectations and regulations.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                NA
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                Positive Implications:<br /> Investments in sustainable product development and quality improvements enhance brand reputation, drive customer loyalty, and result in greater market share and reduced risk of regulatory penalties or product recalls.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>2</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>Resource Circularity (Including EPR & General Waste Management)</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>R</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                Evolving EPR mandates for various waste categories, such as end-of-life vehicles, plastics, batteries, and e-waste, introduce compliance risks and operational challenges. These are compounded by general waste management obligations that require extensive recycling and disposal measures.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                The Company addresses this risk through initiatives like CERO Recycling for vehicle takebacks, onboarding of lithium-ion battery recyclers, authorized plastic recyclers, and used oil collection via dealerships. Supplier engagement ensures compliance across all material streams.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                Negative Implications:<br /> These initiatives involve increased compliance costs and investments in waste infrastructure and traceability.
                                                <br /><br />
                                                Positive Implications:<br />They reduce the long-term risk of fines and operational disruption due to non-compliance.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>3</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>Water Management</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>R</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                Operating in water-stressed geographies exposes M&M to risks of resource scarcity, operational disruptions, and regulatory restrictions. Water management is critical to ensure long-term production stability.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                The Company has adopted proactive water conservation strategies, including rainwater harvesting systems, Zero Liquid Discharge (ZLD) installations, and water recycling initiatives across sites to minimize freshwater dependency.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                Positive Implications:<br /> While capital-intensive initially, these measures mitigate long-term operational and regulatory risks, protecting productivity and reducing potential future liabilities.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>4</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>Carbon Emissions</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>R</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                The Company's operational activities contribute to its carbon footprint. Without mitigation, emissions could lead to inefficiencies, investor concerns, and reputational risks.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                The Company is investing in renewable energy, improving energy efficiency, and deploying emissions tracking systems. Projects such as 'Project Hariyali' (afforestation) and decarbonization roadmaps form part of the risk mitigation strategy.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                Negative Implications:<br /> These investments lead to higher capital and operational expenditure in the short term.<br /><br />Positive Implications:<br />They help avoid regulatory penalties and maintain competitiveness.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }} align='center'>5</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>Carbon Emissions</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>O</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>
                                                The Company’s commitment to becoming carbon neutral by 2040 positions the Company as a sustainability leader. This aligns with global climate goals and presents avenues for innovation, efficiency, and stakeholder engagement.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>
                                                NA
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>
                                                Positive Implications:<br /> Transitioning early to a low-carbon business model unlocks access to green financing, improves brand equity, and reduces long-term costs through energy savings and process optimization.<br />The Company is transitioning toward low-carbon operations through clean energy adoption, green technologies, and emission offset programs. Internal carbon pricing and decarbonization strategies support the 2040 net-zero target.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }} align='center'>6</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>Corporate Social Responsibility ('CSR')</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>O</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                In alignment with the Group’s RISE Philosophy, CSR at Mahindra is an integral part of the business. There is a defined CSR Policy which outlines the CSR strategy of investing in projects that address nation building priorities as well as focus on local developmental needs across the locations of the Company. The flagship CSR Initiatives undertaken by the Company focus on Empowering Girls through education, Empower Women through skills training, Support women by strengthening maternity and newborn healthcare and environment conservation. These align to the UN SDG Goals and CSR Framework laid down by the Government and the Company’s ESG goals.
                                                <br /><br />
                                                <strong>P1:</strong> Anti-Corruption & Anti-Bribery Policy, Code of Conduct for Directors, Policy on Appointment of Board of Directors, Code for Fair Disclosure of UPSI, Tax Policy, Materiality Policy, Related Party Transaction Policy, Whistle Blower Policy, Code of Conduct for Employees, Policy for Remuneration, Familiarisation Programme
                                                <br /><br />
                                                <strong>P2:</strong> Suppliers Code of Conduct, Environment Policy, Zero Waste to Landfill
                                                <br /><br />
                                                <strong>P3:</strong> Safety Policy, Human Rights Policy, Whistle Blower Policy, Code of Conduct for Employees, Supplier Code of Conduct
                                                <br /><br />
                                                <strong>P4:</strong> Corporate Social Responsibility Policy, Supplier Code of Conduct, Code Highlights for Business Partners, Investor Grievance Redressal Policy
                                                <br /><br />
                                                <strong>P5:</strong> Human Rights Policy, Code of Conduct for Employees, Policy on Prevention of Sexual Harassment, Supplier Code of Conduct
                                                <br /><br />
                                                <strong>P6:</strong> Environment Policy, Biodiversity Policy, Zero Waste to Landfill, Water Policy, Conflict Mineral Policy, Supplier Code of Conduct
                                                <br /><br />
                                                <strong>P7:</strong> Code of Conduct & Ethics
                                                <br /><br />
                                                <strong>P8:</strong> Corporate Social Responsibility Policy, Supplier Code of Conduct, Code Highlights for Business Partners, Investor Grievance Redressal Policy
                                                <br /><br />
                                                <strong>P9:</strong> Code of Conduct & Ethics, Privacy Policy, Policy on Advertising and Marketing, Information Security Management System Policy
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                NA
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD" }}>
                                                Positive Impact:<br /> In compliance with the requirement under the Companies Act, 2013, the Company has spent 2% of the average net profit for the last three financial years on CSR Initiatives during the reporting year.<br /><br />
                                                The CSR Initiatives helped achieve the following positive outcomes: <br />
                                                1. Empowering Girls Initiative is enabling holistic development by integrating curricular and extracurricular activities in schools, helping girls transition more seamlessly from school to higher education and employment opportunities.<br />
                                                2. Womens Economic Empowerment has created possibilities for women to have access to opportunities to enhance their socio-economic status through employability and career readiness. This initiative also supports women farmers to enhance their livelihoods by adapting regenerative agricultural practices.<br />
                                                3. Jal Samriddhi (Water Conservation) efforts have contributed to water security, biodiversity, improved soil and agri-practices resulting in irrigation and water conservation.<br />
                                                4. Maternity and newborn care Initiative will open avenues to quality health care and treatment for needy patients
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }} align='center'>7</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>Health & Safety</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>R</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>
                                                Health and safety lapses can result in injury, legal issues, and production losses. Ensuring workforce well-being is vital for sustainable business operations.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>
                                                The Company has instituted robust health and safety systems that include frequent training, regular audits, and proactive risk assessments to create a strong safety culture and prevent incidents across sites.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>
                                                Positive Implications:<br /> While there are costs associated with maintaining high safety standards, these measures significantly reduce the financial and reputational impact of workplace incidents, regulatory actions, or downtime.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }} align='center'>8</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>Sustainable Supply Chain</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>R</TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>
                                                The supply chain poses ESG risks due to its complexity, dependency on critical materials, and increasing scrutiny from stakeholders. Any disruptions or lack of traceability can result in reputational and operational risks.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>
                                                The Company has embedded ESG due diligence across its supply base as a core element of its supplier governance and risk management framework. Supplier risks, including ESG, health and safety, labour, and operational risks, are systematically identified and monitored through screening and periodic third-party assessments and audits.<br /><br />
                                                To support long-term supplier transition, the Company implements a Supplier Business Capability Building (SBCB) Programme.<br /><br />
                                                The Company continues to strengthen supply chain resilience through local sourcing and supplier diversification strategies.
                                            </TableCell>
                                            <TableCell sx={{ border: "1px solid #C3C4BD !important" }}>
                                                Positive Implications:<br /> While implementing responsible sourcing and supplier capacity-building increases near-term costs, these measures are expected to reduce exposure to long-term disruptions, supply shortages, and reputational risks, thereby ensuring stable margins.
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Collapse>
                </Box>
            </Box>
        </Container >
    )
}

export default Sectiona;